import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ILink } from "src/@types";
import { Ii18nInterpolationObject } from "src/@types/i18next";
import { Link } from "src/components/Link";

interface Props extends Pick<ILink, "href"> {
  label: string | Ii18nInterpolationObject;
  icon: string;
}

export const HowToBuyItem: FC<Props> = ({ icon, label, href }) => {
  const { t } = useTranslation();

  const title = typeof label === "string" ? label : t(label.i18nKey);

  return (
    // <Link href={href} className="!scale-100 !brightness-100 group">
    <div className="flex flex-col gl:flex-row items-center gap-4 h-full bg-white-pink p-5 border border-black-base border-opacity-20 rounded-20">
      <img src={icon} alt={title} className="w-14 h-14 xl:w-16 xl:h-16" />

      <h4 className="xl:text-22 text-blue-dark text-center md:text-start">
        {title}
      </h4>
    </div>
    // </Link>
  );
};
